import clsx from "clsx";
import type { FunctionComponent } from "react";

import { useAnalytics } from "@voxmedia/duet-context/context/analytics-context";
import {
  useLoopNavContext,
  LoopNavComponentProps,
} from "@voxmedia/duet-context/context/loop-nav-context";
import { SELECTORS } from "@voxmedia/duet-ui/config";
import { withGracefulErrorBoundary } from "@voxmedia/duet-ui/errors/GracefulErrorBoundary";

import * as styles from "./VergeLoopNav.css";

const VergeLoopNav: FunctionComponent<LoopNavComponentProps> = () => {
  const { loopNavData } = useLoopNavContext();
  const analytics = useAnalytics();

  if (!loopNavData) {
    return null;
  }

  const { sections, title } = loopNavData;

  return (
    <div className={clsx(SELECTORS.LoopNav, styles.wrapper)}>
      <div className={styles.container}>
        <span className={styles.subContainer}>
          <span className={styles.title}>{title}</span>
          {sections.map(({ text: title, permalink }) => (
            <span className={styles.section} key={title}>
              {permalink ? (
                <a
                  href={permalink}
                  onClick={() =>
                    analytics?.emit({
                      event: "loop_nav_click",
                      loop_nav_click: {
                        url: permalink,
                        name: title,
                      },
                    })
                  }
                >
                  {title}
                </a>
              ) : (
                <span>{title}</span>
              )}
            </span>
          ))}
        </span>
      </div>
    </div>
  );
};

export default withGracefulErrorBoundary(VergeLoopNav, {
  context: "VergeLoopNavErrorBoundary",
});
